var shared =
{
    state:
    {
        filter: 'open',
        selectedLocations: [],
        selectedEmployees: [],
        memberships: [],
        data: [],
        multipleCosts: false, // set to true if currently displayed hours have multiple costs to choose from (need to show cost column then!)
        multipleLocations: false,
        sorting: 'desc',

        comments: [],
        comment: null,
    },

    getComments(id)
    {
        return _.orderBy(shared.state.comments.filter(item =>
        {
            return id === item.item.id;
        }), ['localized'], ['asc']);
    },

    removeComment(id)
    {
        shared.state.comments = _.remove(shared.state.comments, (item) =>
        {
            return item.id !== id;
        });
    },
};

export default shared;



// WEBPACK FOOTER //
// ./src/js/pages/hours/shared.js